import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { NetworkService } from '../network.service';
import { Router } from '@angular/router';
import { VcaAlertsService } from './../../../../../../common/vca-alerts';
import { NgForm } from '@angular/forms';
import  { IpValidationUtils  } from './../../../../../../common/validations/ip-validation-utils';

const _ = require('lodash');

@Component({
    selector: 'ipscope',
    template: require('./ipscope-dialog.html')
})

export default class IPScope {
    @Input('openIPScopeDialog') isVisible: boolean;
    @Input ('ipScope') ipScope: any ;
    @Input ('title') title: String;
    @Input('canEditGatewayIP') canEditGatewayIP: boolean;
    @Input('ipScopeOKBtnText') ipScopeOKBtnText: string;

    @Output('cancel') cancelEventEmitter = new EventEmitter();
    @Output('save') saveEventEmitter = new EventEmitter();

    @ViewChild('ipScopeForm') ipScopeForm: NgForm;

    private allRangesValid: boolean = true;
    private ipValidationUtils : IpValidationUtils = new IpValidationUtils();

    constructor() {
    }

    saveNetworkIPRange(event, index: number) {
        let value = event.target.value;
        let range = {};
        let ipRangeArr: string[] = value.split('-', 2);
        let startAddress = ipRangeArr[0].trim();
        let endAddress = '';
        if (ipRangeArr.length > 1) {
             endAddress = ipRangeArr[1].trim();
        } else {
            if (this.ipValidationUtils.isIpValid(startAddress)) {
                endAddress = startAddress;
            }
        }
        this.ipScope.networkIpRanges[index] = {startAddress: startAddress, endAddress: endAddress};
    }
    addNetworkIPRange(event, value: any) {
        this.ipScope.networkIpRanges.push({});
    }
    getIPRangeValue(ipRange: any) {
        let rangeValue: string = '';
        if (ipRange.hasOwnProperty('startAddress')) {
            rangeValue = ipRange.startAddress;
            if (ipRange.endAddress !== '') {
                rangeValue = ipRange.startAddress + ' - ' + ipRange.endAddress;
            }
        }
        return rangeValue;
    }
    removeNetworkIPRange(value, i: number) {
        this.ipScope.networkIpRanges.splice(i, 1);
    }

    cancel() {
        if (this.cancelEventEmitter) {
            this.allRangesValid = true;
            this.ipScopeForm.form.reset();
            this.cancelEventEmitter.emit();
        }
    }

    save(formData) {
        this.allRangesValid = false ;
        let copyOfFormData = _.cloneDeep(formData);

        for (let ipRange of this.ipScope.networkIpRanges) {
            if (this.ipScope.gateway) {
                if (!this.ipValidationUtils.isRangeValid(ipRange.startAddress,
                    ipRange.endAddress, this.ipScope.gateway, this.ipScope.prefixLength)) {
                        this.allRangesValid = false;
                        return;
                }
            } else {
                if (!this.ipValidationUtils.validateIpRangeUsingPrefix(ipRange.startAddress, ipRange.endAddress, this.ipScope.prefixLength)) {
                    this.allRangesValid = false;
                    return;
                }
            }
        }
        this.allRangesValid = true;
        if (copyOfFormData.gateway === '') {
            delete copyOfFormData.gateway;
        }
        if (copyOfFormData.primaryDns === '') {
            delete copyOfFormData.primaryDns;
        }
        if (copyOfFormData.secondaryDns === '') {
            delete copyOfFormData.secondaryDns;
        }
        if (copyOfFormData.dnsSuffix === '') {
            delete copyOfFormData.dnsSuffix;
        }
        if (this.saveEventEmitter) {
            this.saveEventEmitter.emit({
                ipScope: copyOfFormData
            });
         }

         this.ipScopeForm.form.reset();
    }

}


// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/networks/dialogs/ipscope-component.ts